import { IDemo, E3DDemoNameVals, DemoIds } from 'types'
import { getSharedAsset } from '../../helpers/utils'

const intro = getSharedAsset('transforming-the-fan-experience-intro.mp4', 'demos', 'videos')
const video = getSharedAsset('transforming-the-fan-experience.mp4', 'demos', 'videos')
const poster = getSharedAsset('transforming-the-fan-experience.png', 'demos', 'posters')
const monolith = getSharedAsset('transforming-the-fan-experience.png', 'demos', 'monoliths')
const nextDemoThumbnail = getSharedAsset('shot-tracker.png', 'demos', 'thumbnails')

export const transformingTheFanExperience: IDemo = {
  id: DemoIds.transformingTheFanExperience,
  intro,
  video,
  poster,
  monolith,
  end: {
    header: 'Transforming the fan experience.',
    body:
      'For years, the ambitions of innovative organizations have outpaced the cloud’s ability to meet them. Not anymore. Introducing Verizon 5G Edge, the first mobile edge compute platform with AWS Wavelength in the world.',
    nextDemoText: 'The future is here.',
    nextDemo: E3DDemoNameVals.shotTracker,
    nextDemoId: DemoIds.shotTracker,
    nextDemoThumbnail,
    previousDemoId: DemoIds.mecAndSmartVenues
  }
}
